import React, {useImperativeHandle, useRef, useContext} from 'react';
import {v4 as uuid} from 'uuid';
import {FaAngleRight} from 'react-icons/fa';
import {isMobile} from 'react-device-detect';
import {api, Context} from '../../../../services';

import Art from '../../../../assets/img/art.jpg';

import {Button} from '../../../../styles';

const CALLER = 'MODAL_CHOICE';

const ModalChoice = ({onAdvance, capaParceiro, corPrimaria}) => {
  const [authState] = useContext(Context);

  const sizeRef = useRef();

  useImperativeHandle(ref, () => ({
    ref: sizeRef,
    values: () => ({caller: CALLER, data: {modal: 0, uuid: uuid()}}),
  }));

  return (
    <form className="formStep" style={{height: isMobile ? 'auto' : '100%'}}>
      <div className="controlForms">
        <div className="leftSide" style={{padding: 0}}>
          <img
            src={!!capaParceiro ? capaParceiro : Art}
            alt="Art"
            style={{
              maxHeight: isMobile ? '400px' : '100%',
              maxWidth: '100%',
              objectFit: 'cover',
              borderTopLeftRadius: '10px',
            }}
          />
        </div>
        <div
          className="rightSide"
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: '50px',
          }}>
          <div>
            <h1 style={{fontSize: '3rem', color: !!corPrimaria ? corPrimaria : '#023a86', margin: '0'}}>Boas-vindas</h1>
            <p style={{fontSize: '1.5rem', marginBottom: '3em'}}>ao Bici SURA e Bici SURA Essencial</p>
          </div>
          <div className="formGroup">
            <div className="group">
              <h1
                style={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                  color: !!corPrimaria ? corPrimaria : '#023a86',
                }}>
                O que deseja realizar?
              </h1>
              <div style={{display: 'flex'}}>
                <Button primaryColor={corPrimaria} onClick={() => onAdvance(0)}>
                  Realizar cotação de Bike <FaAngleRight />
                </Button>
                <Button primaryColor={corPrimaria} style={{marginLeft: 5, paddingLeft: 7}} onClick={() => onAdvance(2)}>
                  Realizar cotação Bici Sura Essencial
                  <FaAngleRight />
                </Button>
              </div>
              <div style={{display: 'flex'}}>
                <Button primaryColor={corPrimaria} black onClick={() => onAdvance(1)}>
                  Realizar cotação de Modais elétricos <FaAngleRight />
                </Button>

                <Button primaryColor={corPrimaria} black style={{marginLeft: 5, paddingLeft: 7}} onClick={() => onAdvance(3)}>
                  Realizar cotação E-Moto Sura
                  <FaAngleRight />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default React.memo(ModalChoice);
export const ref = React.createRef();
